import BinanceIcon from '../assets/images/BitcoinWallets/Binance.svg';
import LeatherIcon from '../assets/images/BitcoinWallets/Leather.svg';
import MetaMaskIcon from '../assets/images/BitcoinWallets/MetaMask.svg';
import UniSatIcon from '../assets/images/BitcoinWallets/UniSat.svg';
import XversIcon from '../assets/images/BitcoinWallets/Xvers.svg';
import InjectedIcon from '../assets/images/BitcoinWallets/Injected.svg';
import WalletConnectIcon from '../assets/images/BitcoinWallets/walletConnect.svg';
import { AIRDROP_API_MAP, supportedChains } from 'configs/evm-chains';
import { DESTINATION_CHAINS } from 'pages/TransferPage/TransferPage.constants';
export const getWalletIcon = (connector) => {
    if (connector.icon) {
        return connector.icon;
    }
    switch (connector.id) {
        case 'xverse':
            return XversIcon;
        case 'unisat':
            return UniSatIcon;
        case 'binancew3w':
            return BinanceIcon;
        case 'metamask_snap':
            return MetaMaskIcon;
        case 'metaMaskSDK':
            return MetaMaskIcon;
        case 'leather':
            return LeatherIcon;
        case 'injected':
            return InjectedIcon;
        case 'walletConnect':
            return WalletConnectIcon;
    }
};
// shortens the address to 6 characters by changing middle characters to ellipsis
export const shortenAddress = (address, start, end) => `${address.slice(0, start ?? 5)}...${address.slice(end ?? -4)}`;
export const getExplorerUrl = (chainId, hash, type) => {
    const chain = supportedChains.find(c => c.id === chainId);
    return chain ? `${chain.blockExplorers.default.url}/${type}/${hash}` : '#';
};
export const getAirdropApiUrl = (chainId) => {
    if (!chainId) {
        return '';
    }
    return AIRDROP_API_MAP[chainId];
};
export const getDestinationChainById = (chainId) => {
    return DESTINATION_CHAINS.find(chain => chain.id === chainId) || null;
};
